import { jsPDF } from "jspdf";
import Intestazione from "../../assets/intestazione-Giuvi-3.png";

async function loadImageAsDataUrl(src) {
  try {
    const res = await fetch(src);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    return null;
  }
}

export async function downloadDettaglioSpesaPdf({ spesa, fileName }) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 15;
  const marginRight = 15;

  const headerImgData = await loadImageAsDataUrl(Intestazione);
  const addHeader = () => {
    const logoX = marginLeft;
    const logoY = 10;
    const logoW = 50;
    const textX = headerImgData ? logoX + logoW + 8 : marginLeft;
    const line1Y = 16;
    const line2Y = 22;
    if (headerImgData) {
      try {
        doc.addImage(headerImgData, "PNG", logoX, logoY, logoW, 0);
      } catch (_) {}
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    const autore =
      spesa?.autore?.displayName || spesa?.autore?.email || "Autore";
    doc.text(
      `${spesa?.nome || "Spesa"} - ${spesa?.dettagli || ""}`.trim(),
      textX,
      line1Y
    );
    doc.text(
      `Importo: €${spesa?.importo ?? "-"} • Autore: ${autore}`,
      textX,
      line2Y
    );
  };

  addHeader();

  // Dati principali
  doc.setFontSize(11);
  let curY = 35;
  const rows = [
    [
      "Data",
      spesa?.data
        ? spesa.data.toDate
          ? spesa.data.toDate().toLocaleDateString()
          : new Date(spesa.data).toLocaleDateString()
        : "-",
    ],
    ["Settore", spesa?.settore?.toUpperCase?.() || spesa?.settore || "-"],
    ["Pagamento", spesa?.pagamento || "-"],
    ["Protocollo", spesa?.protocollo || "N/A"],
  ];
  rows.forEach(([label, value]) => {
    doc.text(`${label}: ${value}`, marginLeft, curY);
    curY += 7;
  });

  // Immagine se presente
  if (spesa?.fotoUrl) {
    try {
      const imgData = await loadImageAsDataUrl(spesa.fotoUrl);
      if (imgData) {
        const imgX = marginLeft;
        const imgY = curY + 5;
        const imgW = pageWidth - marginLeft - marginRight;
        doc.addImage(imgData, "JPEG", imgX, imgY, imgW, 0);
      }
    } catch (_) {}
  }

  const defaultName = `Ricevuta_${(
    spesa?.autore?.displayName || "Utente"
  ).replace(/[^a-zA-Z0-9_-]/g, "_")}_${(spesa?.settore || "Settore").replace(
    /[^a-zA-Z0-9_-]/g,
    "_"
  )}.pdf`;
  doc.save(fileName || defaultName);
}
